import script from "./TapToInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TapToInput.vue?vue&type=script&setup=true&lang=ts"

import "./TapToInput.vue?vue&type=style&index=0&id=a86e530e&lang=css"

const __exports__ = script;

export default __exports__